module.exports = __webpack_public_path__ + "img/news.e5eacb49.png";